import { useState, useEffect } from "react"
import Post from "../../api/Post"
import { GET_CONSENTIMIENTO_INFORMADO } from "../../api/Routes"
import { getTokenExternal } from "../../utils/getTokenExternal"

function ConsentimientoTeleSalud({namePaciente, noDocumento, nameDoctor, nameAccount, configuration, initialData, setDataRecord, extraClass='font-size-08rem mb-0'}){
    //console.log(initialData)
    const [content, setContent] = useState('')
    useEffect(() => {
        let d = {
            account: {
                id: initialData.account.id
              },
            documentNumber: initialData.documentNumber,
            identityDocumentType: {
            id: '',
            name: '',
            code: initialData?.identityDocumentTypeModel?.code
            },
            lastName: initialData.lastName,
            expediente: initialData.doctorName,
            name: `${initialData.name} ${initialData.middleName}` ,
            seccondSurname: initialData.seccondSurname,
            nombreCompleto:``,
            nationality: initialData.especialidadName         
        }
        async function getConsentimiento(){
            try {
                const tokenObj = await getTokenExternal(initialData.company ? initialData.company : initialData.account.partner.company);
                if(tokenObj.status===200){
                    const {access_token} = tokenObj.data
                    const response = await Post({url: `${GET_CONSENTIMIENTO_INFORMADO}`, data: d, header: true, access_token:access_token})
                    //console.log(response)
                    if(response.data.state){
                        setContent(response.data.data.data)
                        if(setDataRecord){
                            setDataRecord(response.data.data.data)
                        }
                    }
                   
                }                
            } catch (error) {
                
            }     
        }
        getConsentimiento();
    },[])
    return(
        <p className={extraClass}>
            <span dangerouslySetInnerHTML={{ __html: content}}></span>            
        </p>
    )
}

export default ConsentimientoTeleSalud